import {IndependentList} from "./independent-list";

// ConditionalValue({
//     _key: "",
//     disabled: false,
//     renderShadow: (next) => next(123),
//     next,
// })

/**
 * If disabled, then render undefined
 */
export const ConditionalValue = ({_key=null, disabled=false, renderShadow, next: rootNext}) => IndependentList({
    list: disabled ? [] : [{key: _key, render: renderShadow}],
    next: (list) => rootNext(list[0]),
});

